import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

export const OHNE_LABEL_ROLES = ["versand", "manager", "admin"];
const DIENSTE = ["Selbstabholung", "DPD", "GLS", "UPS", "Hermes", "Deutsche Post"];

// Vorauswahl: Versandposition des Auftrags ohne DHL-Label (z. B. „Selbstabholung“)
export function initialOhneLabel(order) {
  const vp = (order?.positionen || []).find((p) => p.typ === "versand");
  const abholung = /abhol/i.test(`${vp?.name || ""} ${vp?.beschreibung || ""}`);
  const on = !!vp && (vp.versand_label_typ === "kein" || abholung);
  return { on, dienst: abholung ? "Selbstabholung" : "", tracking: "" };
}

export const isAbholung = (v) => v.dienst.trim().toLowerCase() === "selbstabholung";

export function OhneLabelOption({ value, onChange }) {
  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <div className="p-3 border rounded-md space-y-2" data-testid="versand-ohne-label">
      <label className="flex items-center gap-2 text-sm font-medium cursor-pointer">
        <Checkbox checked={value.on} onCheckedChange={(v) => set({ on: !!v })} data-testid="versand-ohne-label-checkbox" /> Ohne DHL-Label buchen
      </label>
      {value.on && (
        <div className="grid grid-cols-2 gap-3">
          <div><Label htmlFor="versand-dienst" className="text-xs">Versanddienst / Art (optional)</Label>
            <Input id="versand-dienst" list="versand-dienste" placeholder="z. B. Selbstabholung, DPD" value={value.dienst} onChange={(e) => set({ dienst: e.target.value })} data-testid="versand-dienst-input" />
            <datalist id="versand-dienste">{DIENSTE.map((d) => <option key={d} value={d} />)}</datalist></div>
          {!isAbholung(value) && (
            <div><Label htmlFor="versand-tracking" className="text-xs">Sendungsnummer (optional)</Label>
              <Input id="versand-tracking" value={value.tracking} onChange={(e) => set({ tracking: e.target.value })} data-testid="versand-tracking-input" /></div>
          )}
          <p className="col-span-2 text-[11px] text-slate-500">Bucht Inhalt, Teilmengen und Kundenteile wie ein normaler Versand – nur ohne DHL-Label.{isAbholung(value) && " Die Kunden-E-Mail meldet „zur Abholung bereit“."}</p>
        </div>
      )}
    </div>
  );
}
